import flagCs from '../images/flag-cs@2x.png';
import flagEu from '../images/flag-eu@2x.png';

const CZK = 'CZK';
const EUR = 'EUR';

const currencyToFlag = {
	[CZK]: flagCs,
	[EUR]: flagEu,
};

const getFlag = (currency) => {
	return currencyToFlag[currency] || null;
};

const getOptions = (currencies) => {
	if (!currencies) return [];

	const options = [];

	for (let currency of Object.values(currencies)) {
		options.push({
			value: currency.id,
			label: `${currency.code} (${currency.symbol})`,
			image: getFlag(currency.code),
		})
	}

	return options;
};

export default {
	CZK,
	EUR,

	getOptions,
}




// WEBPACK FOOTER //
// ./src/enums/Currency.js